<template>
  <div id="app">
    <component :is="isWatch"></component>
     
  </div>
</template>

<script>
import '@src/assets/css/common.scss'
import Home from '@src/componentsNew/Home'
import HomeMobile from '@src/componentsNew/HomeMobile'
export default {
  name: 'App',
  data(){
    return {
      isWatch:'Home'
    }
  },
  mounted(){
       document.body.clientWidth > 768 ? this.isWatch = "Home" : this.isWatch = "HomeMobile"
  },
  components:{
    Home,
    HomeMobile
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue